import { type ItemTypeBase, ItemWrapperTypeBase, SectionWrapperTypeBase } from "../js/enums.ts";

export enum ItemTypeCustom {
	CONTACT = 'contact',
	MAP = 'map',
	MAP_DELIVERY = 'mapDelivery',
	LATEST = 'news',
	NEWS = 'singleNews',
	SERVICE = 'service',
	PAGEBOX = 'pageBox',
	SURVEY = 'survey',
	NEWSLETTER = 'newsletter',
	MENUITEM = 'menuItem',
}
export type ItemType = ItemTypeBase | ItemTypeCustom;


export enum ItemWrapperTypeCustom {
	BLOCKQUOTE = 'blockquote',
}
export type ItemWrapperType = ItemWrapperTypeBase | ItemWrapperTypeCustom;


export enum SectionWrapperTypeCustom {
	BLOCKQUOTE = 'blockquote',
}
export type SectionWrapperType = SectionWrapperTypeBase | SectionWrapperTypeCustom;

